export default __webpack_public_path__ + "static/media/benchmaking_testseries.7e64b40e.png";